export const MAX_MANUAL_ACCOUNT_IDS = 100

// Accepts account ids separated by any non numeric character and removes duplicates,
// mirroring the cleanup the backend does before processing the batch.
export const parseAccountIds = (value: string): string[] => [
  ...new Set(value.split(/[^\d]/).filter((accountId) => /\d/.test(accountId))),
]
